import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

interface BackdropComponentProps {
    visible: boolean;
    color?: string;
};

const BackdropComponent: React.FC<BackdropComponentProps> = ({ visible, color = "#ffffff" }) => {
    return (
        <Backdrop sx={{ zIndex: 1 }} open={visible}>
            <CircularProgress size={50} sx={{ color: color }} />
        </Backdrop>
    );
};

export default BackdropComponent;